// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"64a48186","353":"a40f110c","453":"1519601c","595":"a4147364","604":"1ae799c1","664":"ece7debb","979":"5ce0afba"}[chunkId] + ".chunk.js";
};